/* * @Author: Wei Guojun * @Date: 2021-04-09 10:11:23 * @Last Modified by: Wei
Guojun * @Last Modified time: 2021-10-22 17:43:33 */
<template>
  <div class="home">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      size="small"
    >
      <div class="model sender">
        <el-row class="_header"></el-row>
        <div class="from" v-if="sendModel == '填写寄件人'">
          <div class="header_title">
            <img src="@/assets/images/icon_ji.png" alt />
            <span>寄件人信息</span>
          </div>
          <el-radio-group v-model="sendModel" size="mini" class="chooseModel">
            <el-radio-button label="选择寄件人"></el-radio-button>
            <el-radio-button label="填写寄件人"></el-radio-button>
          </el-radio-group>
          <el-row>
            <el-col class="title" :span="2">
              <div>智能解析</div>
            </el-col>
            <el-col :span="21">
              <div class="flexBetween">
                <el-input
                  type="textarea"
                  placeholder="直接粘贴文字，图片可智能识别
例如： 张三 18888888888 上海 上海市 黄浦区 延安东路888号88室"
                  v-model="ruleForm.send.analysis"
                  clearable
                  @paste.native="ImgpasteFun($event,'send')"
                  @input="doAnalysis(ruleForm.send.analysis, 'send')"
                >
                </el-input>
                <div class="picBox">
                  <i class="el-icon-picture"></i><br/>
                  图片上传
                  <input
                    class="file"
                    name="image"
                    type="file"
                    accept="image/png,image/gif,image/jpeg"
                    @change="cropperImg($event,'send')"
                  /> 
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div><span class="span">*</span>姓名</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <el-form-item style="margin-left: 0" prop="send.name">
                      <el-autocomplete
                        placeholder="请输入姓名"
                        suffix-icon="el-icon-user"
                        v-model="ruleForm.send.name"
                        @change="idChecked"
                        clearable
                        :fetch-suggestions="
                          (queryString, cb) => {
                            querySearch(queryString, cb, 1)
                          }
                        "
                        :trigger-on-focus="false"
                        @select="
                          (item) => {
                            handleSelect(item, 'send')
                          }
                        "
                      ></el-autocomplete>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div><span class="span">*</span>联系方式</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="send.phone">
                        <el-input
                          type="text"
                          placeholder="请输入联系手机或电话"
                          v-model.trim="ruleForm.send.phone"
                          suffix-icon="el-icon-phone-outline"
                          @change="idChecked"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 15px">
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div><span class="span">*</span>省/市/区</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="send.pca">
                        <el-cascader
                          @change="changeAddress('send')"
                          @blur="checkDizhi"
                          ref="send"
                          :options="sender_address"
                          v-model="ruleForm.send.pca"
                          placeholder="请选择省/市/区"
                          filterable
                        ></el-cascader>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div style="position: relative;">
                <el-row>
                  <el-col class="title" :span="4">
                    <div><span class="span">*</span>详细地址</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="send.address">
                        <el-input
                          @blur="checkDizhi"
                          type="text"
                          placeholder="请输入详细地址"
                          suffix-icon="el-icon-map-location"
                          v-model.trim="ruleForm.send.address"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>            
                </el-row>
                <el-button type="text" class="inputClear" @click="inputClear('send')">一键清空</el-button>
              </div>
            </el-col>
          </el-row>
          <div class="checkbox" v-if="orderType=='send'">
            <el-checkbox
              v-model="ruleForm.send.save_info"
              label="保存到我的寄件人"
              name="type"
            ></el-checkbox>
          </div>
          <el-row v-if="orderType=='customerSend'">
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div><span class="span">*</span>实名认证</div>
                  </el-col>
                  <el-col class="input" :span="19">
                    <div @click="dialogFormVisible = true" class="realBox">
                      <span v-if="realFlag">已实名/{{ realForm.name }}</span>
                      <span v-else>未实名</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="11"></el-col>
          </el-row>
        </div>
        <div class="from" v-else>
          <div class="header_title">
            <img src="@/assets/images/icon_ji.png" alt />
            <span>寄件人信息</span>
          </div>
          <el-radio-group v-model="sendModel" size="mini" class="chooseModel">
            <el-radio-button label="选择寄件人"></el-radio-button>
            <el-radio-button label="填写寄件人"></el-radio-button>
          </el-radio-group>
          <el-row>
            <el-col class="title" :span="2">
              <div><span class="span">*</span>寄件人信息</div>
            </el-col>
            <el-col class="input" :span="22">
              <el-form-item style="margin-left: 0" v-if="!focusmodel">
                <el-input v-model="chooseAddress" 
                 @focus="focusmodel = true"
                 readonly 
                 placeholder="请选择寄件人信息，或者直接输入寄件人姓名从已有地址中快速选择">
                <el-button slot="append" type="primary" @click="selectAddress('send')" class="senderChoose">选择</el-button>
                </el-input>
              </el-form-item>
              <el-form-item style="margin-left: 0;" v-else>
                <div style="position: relative;">
                <el-select
                  @blur="focusmodel = false"
                  v-model="searchsender"
                  filterable
                  remote
                  reserve-keyword
                  @change="(item) => {handleSelect({id:item}, 'send')}"
                  :placeholder="chooseAddress ? chooseAddress :'请选择寄件人信息，或者直接输入寄件人姓名从已有地址中快速选择'"
                  :remote-method="(queryString, cb) => {querySearch(queryString, cb, 1)}"          
                  >
                  <el-option
                    v-for="item in restaurants"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-button type="primary" @click="selectAddress('send')" class="senderChoose" style="position: absolute;right: 30px;z-index: 9;top:0">选择</el-button>
                <!-- <span class="span">*</span> -->
                </div>

              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="orderType=='customerSend'">
            <el-col :span="11">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div><span class="span">*</span>实名认证</div>
                  </el-col>
                  <el-col class="input" :span="19">
                    <div @click="dialogFormVisible = true" class="realBox">
                      <span v-if="realFlag">已实名/{{ realForm.name }}</span>
                      <span v-else>未实名</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="11"></el-col>
          </el-row>
        </div>
      </div>
      <div class="model addressee">
        <el-row class="_header"></el-row>
        <div class="from">
          <div class="header_title">
            <img src="@/assets/images/icon_show.png" alt />
            <span>收件人信息</span>
          </div>
          <div class="addRecever">
            <img src="@/assets/images/add.png" alt />
            <a @click="selectAddress('collect')" href="javascript:void(0)">添加收件人</a>
          </div>
          <el-row
            style="padding-bottom: 15px; margin-bottom: 0"
            :style="
              index == Added_Collect.length - 1
                ? 'border-bottom: 1px dashed #e8e8e8;margin-bottom:15px;'
                : ''
            "
            v-for="(item, index) in Added_Collect"
            :key="index"
          >
            <el-col class="title" :span="2">
              <span v-if="index == 0">已选收件人</span>
            </el-col>
            <el-col :span="20">
              <div class="collect-list">
                <div class="left">
                  <span class="checkdes" v-if="item.status_desc != '正常'">{{item.status_desc}}</span>
                  <span class="rod">{{ index + 1 }}</span>
                  {{ item.name }},{{ item.phone }},{{ item.province }},{{
                    item.city
                  }},{{ item.area }},{{ item.address }}
                </div>
                <div class="right">
                  <span v-if="item.teamData" class="defaultClass"
                    >共享地址</span
                  >
                  <img
                    @click="editAddressRow(index)"
                    :class="item.teamData ? 'mygray' : ''"
                    src="@/assets/images/edit-f.png"
                  />
                  <img
                    @click="removeAddress(index)"
                    src="@/assets/images/reduce.png"
                  />
                  <img
                    v-if="
                      Added_Collect.length > 0 &&
                      Added_Collect.length - 1 == index
                    "
                    @click="selectAddress('collect')"
                    src="@/assets/images/add-f.png"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="collectBox">
            <el-row>
              <el-col class="title" :span="2">
                <div>智能解析</div>
              </el-col>
              <el-col :span="21">
                <div class="flexBetween">
                  <el-input
                    type="textarea"
                    placeholder="直接粘贴文字，图片可智能识别
例如： 张三 18888888888 上海 上海市 黄浦区 延安东路888号88室 "
                    v-model="ruleForm.collect.analysis"
                    clearable
                    @paste.native="ImgpasteFun($event,'collect')"
                    @input="doAnalysis(ruleForm.collect.analysis, 'collect')"
                  >
                  </el-input>
                  <div class="picBox">
                    <i class="el-icon-picture"></i><br/>
                    图片上传
                    <input
                      class="file"
                      name="image"
                      type="file"
                      accept="image/png,image/gif,image/jpeg"
                      @change="cropperImg($event,'collect')"
                    /> 
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div>
                  <el-row>
                    <el-col class="title" :span="4">
                      <div><span class="span">*</span>收件人姓名</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.name">
                          <el-autocomplete
                            placeholder="请输入姓名"
                            suffix-icon="el-icon-user"
                            v-model="ruleForm.collect.name"
                            clearable
                            :fetch-suggestions="
                              (queryString, cb) => {
                                querySearch(queryString, cb, 0)
                              }
                            "
                            :trigger-on-focus="false"
                            @select="
                              (item) => {
                                handleSelect(item, 'collect')
                              }
                            "
                          ></el-autocomplete>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-row>
                    <el-col class="title" :span="4">
                      <div><span class="span">*</span>联系方式</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.phone">
                          <el-input
                            type="text"
                            placeholder="请输入联系手机或电话"
                            v-model.trim="ruleForm.collect.phone"
                            suffix-icon="el-icon-phone-outline"
                            clearable
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 15px">
              <el-col :span="12">
                <div>
                  <el-row>
                    <el-col class="title" :span="4">
                      <div><span class="span">*</span>省/市/区</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.pca">
                          <el-cascader
                            @change="changeAddress('collect')"
                            @blur="checkDizhi"
                            ref="collect"
                            :options="sender_address"
                            v-model="ruleForm.collect.pca"
                            placeholder="请选择省/市/区"
                            filterable
                          ></el-cascader>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="12">
                <div style="position:relative">
                  <el-row>
                    <el-col class="title" :span="4">
                      <div><span class="span">*</span>详细地址</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.address">
                          <el-input
                            type="text"
                            @blur="checkDizhi"
                            placeholder="请输入详细地址"
                            suffix-icon="el-icon-map-location"
                            v-model.trim="ruleForm.collect.address"
                            clearable
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-button type="text" class="inputClear" @click="inputClear('collect')">一键清空</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="addressClose">
              <el-col :span="11">
                <div>
                  <el-row>
                    <el-col class="title" :span="4"> </el-col>
                    <el-col class="input" :span="20" style="color: red">
                      * 此地址暂时存在“网点停发”情况
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <div class="save_addressee_btn">
              <div @click="addCollect">
                <img src="@/assets/images/add.png" alt />
                <a href="javascript:void(0)">确认添加收件信息</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="model other">
        <div class="from">
          <el-row type="flex" style="flex-wrap: wrap" :gutter="38">
              <div class="input-box-n">
                <label class="input-box-lable"><span class="span" style="opacity:1;">*</span>物品信息</label>
                <!-- <el-form-item> -->
                    <el-input
                      class="goods-input"
                      v-model="goodsAweight"
                      @focus="showGoodsPicker = true"
                    />
                  <!-- </el-form-item> -->
              </div>
              <div class="input-box-n">
                <label class="input-box-lable"><span class="span">*</span>付款方式</label>
                <!-- <el-form-item> -->
                     <el-select
                    v-model="maiServe"
                    placeholder="请选择付款方式"
                    style="width: 90%"
                    @focus="getdfAuth"
                    @change="serveChoose"
                  >
                    <el-option
                      v-for="item in addserve"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <!-- </el-form-item> -->
              </div>
              <div class="input-box-n" v-if="orderType =='customerSend' && maiServe == 'pt' ? true : false">
                <label class="input-box-lable"><span class="span">*</span>寄付运费</label>
                <el-input
                class="freight-input"
                  type="text"
                  placeholder="请输入"
                  v-model.trim="daofu_amount"
                  @input="moneyInput"
                  @blur="moenyBlur"
                  clearable
                >
                  <template slot="append">元</template>
                </el-input>
              </div>
              <div class="input-box-n" >
                <label class="input-box-lable"><span class="span">*</span>批货寄件</label>
                <div>
                  <el-switch
                    @change="switchTip"
                    v-model="switchShow"
                    active-color="#FFD44B"
                    inactive-color="#D9D9D9"
                  >
                  </el-switch>
                  <span
                  class="pihuo-tip-n" v-show="!switchShow">相同快递面单打印数量</span>
                  <el-input-number
                    v-show="switchShow"
                    v-model="package_count"
                    :min="1"
                    :max="30"
                    label=""
                    size="small"
                  ></el-input-number>
                  <span v-show="switchShow" style="margin-left:12px;">包裹数量（面单数量）2~30</span>
                </div>
              </div>
          </el-row>
          <!-- type="flex" :gutter="8" -->
          <el-row>
              <div class="input-box-n input-remark-n" style="flex-shrink: 0;" @click.stop>
                <label class="input-box-lable" style="margin-right:0;flex-wrap: nowrap">包裹备注</label>
                <el-input
                  class="order-renark-n"
                  type="text"
                  placeholder="选填项，注意由快递员打印的包裹备注最多只可打出20个字"
                  maxlength="60"
                  height="100%"
                  show-word-limit
                  v-model.trim="textarea"
                  @blur.stop="setPreSave"
                  @focus.stop="focusRemarkPop"
                  style="margin-left:16px;"
                ></el-input>
                <div class="select-n-box1">
                  <div class="select-n-box" v-show="isShowRemarksPop">
                    <div class="scroll-n-box">
                      <div class="remark-scroll-n">
                        <div v-for="(c,index) in remarkArrs" class="itemopt-n" :key="index" @click.stop="selectRemarks(c)" @mouseover="showDel" @mouseout="hideDel">
                          <div>{{c.commonly_order_remark}}</div>
                          <div><i class="el-icon-circle-close" v-show="showDelIcion" @click.stop="handleDelRmearks(c)"></i></div>
                        </div>
                      </div>
                    </div>
                    <div class="add-btn-n-box">
                      <el-input
                      class="remark-input-n"
                      type="text"
                      placeholder="请输入"
                      v-model.trim="addRemarkTemp"
                      clearable
                      maxlength="60"
                    ></el-input>
                      <div class="add-btn-n" @click="handleSaveRemarks"><i class="el-icon-plus"></i>添加</div>
                    </div>
                  </div>
                </div>
              </div>
          </el-row>
        </div>
      </div>
    </el-form>
    <div class="info-title"></div>
    <div class="zzfu-n">
      <div class="header_title">
         <img src="@/assets/images/zzfw.png" alt />
         <span>增值服务</span>
      </div>
      <value-add @servicesType="servicesType" ref="valueAdd" :currenPage="currenPage"></value-add>
    </div>
    <footer>
      <div class="footer">
        <el-button type="success" class="footBtn" @click.prevent="submitKdy"
          >提交快递员打印</el-button
        >
        <el-button
          v-if="(maiServe == 'topay' || onlykdy) ? false : true"
          type='primary'
          class="footBtn"
          @click.prevent="directPrint"
          >立即打印</el-button
        >
        <el-button
          v-if="(maiServe == 'topay' || onlykdy) ? false : true"
          type="warning"
          class="footBtn"
          @click.prevent="waitPrint"
          >先存后打</el-button
        >
      </div>
    </footer>
    <div v-if="dialog" class="zMark">
      <el-dialog
        center
        top="50px"
        width="1000px"
        :title="dialog_title"
        :visible.sync="dialog"
        @close="closeDialog"
      >
        <div
          :style="{ height: address_type == 'editCollect' ? '320px' : '580px' }"
        >
          <v-address
            ref="collectList"
            v-if="address_type == 'collect'"
            :IdList="IdList"
            :forCustmer="false"
          ></v-address>
          <v-send-address
            ref="sendList"
            v-if="address_type == 'send'"
          ></v-send-address>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="智能粘贴" :visible.sync="moreVisble" width="600px" center>
      <span>粘贴说明：智能粘贴多条地址间用换行符隔开，最多支持10条地址</span>
      <div class="forExample">
        <div class="left">例如：</div>
        <div class="right">
          韵达大碗面 13118954372 上海市上海市青浦区盈港东路6679号<br />
          陈静怡 13150456588 云南省丽江市古城区金山白族乡丽江师范高等专科学校
        </div>
      </div>
      <el-input
        type="textarea"
        placeholder="请输入粘贴内容"
        v-model="ruleForm.collect.analysis"
        show-word-limit
      >
      </el-input>
      <div class="flexEnd">
        <el-button
          size="mini"
          type="primary"
          @click="jxBtnfun(ruleForm.collect.analysis, 'collect')"
          >解析</el-button
        >
      </div>
      <div class="cp_title">
        已识别{{ rightNum }}可用地址信息，{{
          errorNum
        }}个异常地址可在上方输入框中修改地址信息,<span>重新点击【解析】</span>
      </div>
      <ul>
        <li v-for="(item, index) in anslsList" :key="index" class="ListItem">
          <span v-if="item.name_error" class="errorTip">{{
            item.name || '缺少姓名'
          }}</span>
          <span v-else>{{ item.name }}</span>
          <span v-if="item.phone_error" class="errorTip">{{
            item.phone || '缺少联系方式'
          }}</span>
          <span v-else>{{ item.phone }}</span>
          <span v-if="item.address_error" class="errorTip"
            >{{ item.province_name || '缺少省名称'
            }}{{ item.city_name || '缺少市名称'
            }}{{ item.district_name || '缺少区名称' }}{{ item.address }}</span
          >
          <span v-else
            >{{ item.province_name }}{{ item.city_name }}{{ item.district_name
            }}{{ item.address }}</span
          >
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureUse" size="mini"
          >确定使用({{ rightNum }})</el-button
        >
      </span>
    </el-dialog>
    <component :is="curComponent[0]" :ref="curComponent[1]"></component>
    <el-dialog title="" :visible.sync="copyVisible" width="30%" center>
      <span>已识别剪贴板，是否要智能解析此条信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false" size="mini"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="centerDialogVisible = false"
          size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
        <el-dialog
      title="请进行实名认证"
      :visible.sync="dialogFormVisible"
      center
      width="500px"
      id="IdCard"
      top="30vh"
    >
      <el-form
        :model="realForm"
        size="mini"
        :rules="IdCardRules"
        ref="IdCardForm"
      >
        <el-form-item label="姓名：" :label-width="formLabelWidth" prop="name">
          <el-input
            v-model.trim="realForm.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="身份证号："
          :label-width="formLabelWidth"
          prop="id"
        >
          <el-input
            v-model.trim="realForm.id"
            placeholder="请输入证件号"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="realbtnShow"
          label="证件类型："
          :label-width="formLabelWidth"
          prop="card_type"
        >
        <el-select v-model="realForm.card_type" placeholder="请选择证件类型">
          <el-option
            v-for="item in card_type_list"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="realbtnShow">
        <el-button @click="dialogFormVisible = false" size="mini"
          >稍后验证</el-button
        >
        <el-button type="primary" @click="subReal" size="mini"
          >立即验证</el-button
        >
      </div>
    </el-dialog>
    <goods-picker
      :visible="showGoodsPicker"
      :initReceipt="true"
      @close="showGoodsPicker = false"
      @picked="handlePickGoods"
    />
    <div v-if="collectShow">
      <el-dialog
        :title="title"
        width="900px"
        top="180px"
        :visible.sync="collectShow"
        center
      >
      <div><editAddress :editObj="editObj" :addOredit="addOredit"></editAddress></div>
      </el-dialog>
    </div>
    <cropper :cropperShow="cropperShow" ref="ImgCropper"></cropper>
  </div>
</template>
<script>
import vAddress from '@/components/address.vue'
import vSendAddress from '@/components/send_address.vue'
import goodsPicker from '@/components/goodsPicker.vue'
import editAddress from "@/components/editAddress";
import cropper from '@/components/cropper';
import home from '@/api/home'
import bindKdy from "@/api/bindKdy";
import valueAdd from '@/components/value_addservices.vue'
import myLocalStorage from '@/util/crypto.js'
import util from '@/util/util'
import { mapGetters } from 'vuex'
import { PrintWaiting, startPrinting } from '@/util/ptintTool.js'
import print from '@/api/print'
import myMinix from '@/mixin/minix'
import Rule from '@/util/rule.js'
let sumbitType = 0
let telReg = /^(400|800)(-)?[016789]\d{2}(-)?\d{4}$/g;
let ghReg = /^\d{3,4}(-)?\d{7,8}$/g;
let phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/g;
export default {
  name: 'home',
  mixins: [myMinix],
  data() {
    return {
      sendModel:'选择寄件人',
      collectShow:false,
      editObj: {},
      addOredit: {
        type: "",
        name: "收件人",
        from:'home',
      },
      daofu_amount: '',
      copyVisible: false,
      province: '',
      city: '',
      // block: '',
      select_type: 'send',
      save_btn: false,
      dialog_title: '选择寄件人',
      dialog: false,
      address_type: '', //选择地址类型
      first_click: true,
      isEdit: false,
      fieldCollect: [
        //收件验证字段
        'collect.name',
        'collect.phone',
        'collect.address',
        'collect.pca',
      ],
      fieldSend: [
        //寄件人验证字段
        'send.name',
        'send.phone',
        'send.address',
        'send.pca',
      ],
      addserve: [
        { label: '寄付', value: 'pt'},
        { label: '到付', value: 'topay'},
      ],
      sender_address: [], // 寄件人地区选项配置
      typeContent: ' ', //物品类型
      goods_weight:1, //物品重量
      maiServe: 'pt', //增值服务
      topayOnoff: false,
      textarea: '', //备注说明
      parcel_id: '', //包裹id
      Added_Collect: [], //已添加过的收件人
      isImport: false, // 编辑临时包裹
      print_btn: false,
      ruleForm: {
        send: {
          save_info: false, // 是否保存信息
          analysis: '', // 解析数据
          isAnalysis: false,
          name: '', // 姓名
          phone: '', // 手机号
          province: '', // 省
          province_code: '', //省编码
          city: '', // 市
          city_code: '', //市编码
          city_list: [], // 市列表数据
          area: '', //区
          area_code: '', //区编码
          area_list: [], //区列表
          address: '', // 详细地址
          pca: '', // 省市区
          address_id: 0, //
        },
        collect: {
          analysis: '', // 解析数据
          isAnalysis: false,
          name: '', // 姓名
          phone: '', // 手机号
          province: '', // 省
          province_code: '', //省编码
          city: '', // 市
          city_code: '', //市编码
          city_list: [], // 市列表
          area: '',
          area_code: '', //区编码
          area_list: [], //区列表
          address: '', // 详细地址
          pca: '', // 省市区
          type: '', //类型
          status_desc: '',
          address_id: 0, //
        },
      },
      rules: Rule,
      Isprint: false,
      editcollectIndex: -1,
      clearstorage: false,
      IdList: [],
      package_count: 1,
      switchShow: false,
      ysdswitch: false,
      ysSwitch: false,
      moreVisble: false,
      anslsList: [],
      dialogFormVisible: false,
      realForm: {
        name: '',
        id: '',
        card_type:'01'
      },
      formLabelWidth: '100px',
      IdCardRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        id: [{ required: true, message: '请输证件号', trigger: 'blur' }],
        card_type: [{ required: true, message: '请输入选择证件类型', trigger: 'blur' }],
      },
      realFlag: false,
      errorNum: 0,
      rightNum: 0,
      rightArr: [],
      searchTimeout: '',
      curComponent: [],
      addressClose: false,
      showGoodsPicker: false,
      onlykdy:false,
      orderType:'send',//寄件类型:默认send-寄快递；customerSend-代客下单
      cropperShow:false,
      focusmodel:false,
      searchsender:'',
      restaurants:[],
      currenPage:'home',
      remarkArrs:[
      {
        identity_name:'承包区',
        identity_code:'7',
        checked:false
      },
      {
        identity_name:'承包区1',
        identity_code:'8',
        checked:false
      },
      {
        identity_name:'承包区3',
        identity_code:'9',
        checked:false
      },
      ],//备注
      addRemarkTemp:'',
      isShowRemarksPop:false,
      showDelIcion:false,
      card_type_list:[
        {label:"大陆居民身份证/临时居民身份证",value:'01'},
        {label:"外国人永久居留身份证",value:'02'},
        {label:"户口薄",value:'03'},
        {label:"中国人民解放军军人身份证",value:'04'},
        {label:"中国人民武装警察身份证",value:'05'},
        {label:"港澳居民来往内地通行证",value:'06'},
        {label:"台湾居民来往大陆通行证",value:'07'},
        {label:"外国公民护照",value:'08'},
        {label:"中国公民护照",value:'09'},
        {label:"港澳台身份证",value:'10'},
        {label:"港澳台居民居住证",value:'11'}
      ]
    }
  },
  computed: {
    ...mapGetters(['getFrom']),
    realbtnShow(){
      let flag = false
      if(this.realForm.id.indexOf("*") != -1){
        flag = false
      }else{
        flag = true
      }
      return flag
    },
    chooseAddress(){
      const sender = this.ruleForm.send
      const data = sender.name + ' '+sender.phone +' '+ sender.province+sender.city+sender.area+sender.address
      return data.trim()
    },  
    goodsAweight(){
      if(this.typeContent && this.goods_weight){
        return this.typeContent+','+this.goods_weight+'KG'
      }else{
        return this.typeContent
      }
    }
  },

  components: {
    vAddress,
    vSendAddress,
    goodsPicker,
    valueAdd,
    editAddress,
    cropper
  },
  created: function () {
    // console.log('===99999',this.$route)
    if(this.$route.query.id=='2'){//代客下单
      this.orderType='customerSend'
      this.sendModel = '填写寄件人'
      this.$store.commit('SET_ROUTE_FROM', '/customer')
      this.$store.state.nav_index = 1
      this.$store.state.activeMenu = '/customer'
      document.title = '韵商宝-代客下单';
    }else{//寄快递
      this.orderType='send'
      this.sendModel = '选择寄件人'
      this.$store.commit('SET_ROUTE_FROM', '/home')
      this.$store.state.nav_index = 0
      this.$store.state.activeMenu = '/home'
      document.title = '韵商宝-首页';
    }
    // this.$store.commit('SET_ROUTE_FROM', '/home')
    this.getCityData()
    home.getRemarks(this).then((res) => {
      this.remarkArrs = res.data.data.remarks
    })
  },
  mounted() {
    window.q = this
    if (this.orderType == 'send'){
      const oldpreSave = myLocalStorage.getItem('preSave')
      if (oldpreSave) {
        const preSave = JSON.parse(oldpreSave)
        this.ruleForm = Object.assign(this.ruleForm, preSave.ruleForm)
        const { name, phone, province_code, city_code, district_code, address } = preSave.ruleForm.send
        if (!name &&!phone &&!province_code &&!city_code &&!district_code &&!address) {
          this.getmorenAddress()
        }
        this.typeContent = preSave.typeContent ?? null
        this.goodsPicker = preSave.typeContent ?? 1
        this.textarea = preSave.textarea
        this.Added_Collect = preSave.Added_Collect || []
        this.daofu_amount = preSave.daofu_amount
        if(preSave.morder_marking_infos){  //是否到付
          preSave.morder_marking_infos.is_df == 1
          ? (this.maiServe = 'topay')
          : (this.maiServe = 'pt')
        }
        this.$nextTick(()=>{
          this.$refs.valueAdd.oncenews(preSave.pri,preSave.express_type,preSave.morder_marking_infos,preSave.onceNews||false)
        })
      }else {
        this.getmorenAddress();
        this.$nextTick(()=>{
          this.$refs.valueAdd.init();
        })
      }
    }
    if (this.orderType == 'customerSend'){
      // Object.assign(this.$data, this.$options.data())
      // this.orderType = 'customerSend'
      this.$data.ruleForm = this.$options.data().ruleForm
      // console.log('this.$data0',this.$data)
      // console.log('this.$data1',this.ruleForm)
      const oldonceNews = myLocalStorage.getItem('onceNews')
      if (oldonceNews) {
        const onceNews = JSON.parse(oldonceNews)
        this.ruleForm = Object.assign(this.ruleForm, onceNews.ruleForm)
        this.typeContent =
          onceNews.typeContent == ''
            ? util.getCookie('oldType') - 0
            : onceNews.typeContent - 0
        this.textarea = onceNews.textarea
        this.daofu_amount = onceNews.daofu_amount
        if(onceNews.morder_marking_infos){  //是否到付
          onceNews.morder_marking_infos.is_df == 1
          ? (this.maiServe = 'topay')
          : (this.maiServe = 'pt')
        }
        this.$nextTick(()=>{
          this.$refs.valueAdd.oncenews(onceNews.pri,onceNews.express_type,onceNews.morder_marking_infos,onceNews.onceNews||false)
        })
        this.idChecked()
      }else{
        this.$nextTick(()=>{
          this.$refs.valueAdd.init();
        })
      }
    }
    if (this.$route.params.chooseRow) {
      const routeObj = JSON.parse(this.$route.params.chooseRow)
      this.ruleForm.collect.name = routeObj.name
      this.ruleForm.collect.phone = routeObj.phone
      this.ruleForm.collect.province = routeObj.province_name
      this.ruleForm.collect.province_code = routeObj.province_code
      this.ruleForm.collect.city = routeObj.city_name
      this.ruleForm.collect.city_code = routeObj.city_code
      this.ruleForm.collect.area = routeObj.district_name
      this.ruleForm.collect.area_code = routeObj.district_code
      this.ruleForm.collect.address = routeObj.address
      this.ruleForm.collect.pca = [
        routeObj.province_code,
        routeObj.city_code,
        routeObj.district_code,
      ]
      this.ruleForm.collect.address_id = routeObj.address_id
    }
    if (this.$store.state.bindKdy == 10 || this.$store.state.bindKdy == 12) {
      this.addserve = [{ label: '寄付', value: 'pt'}]
    }
    window.addEventListener("click", this.colseRemark);
    document.addEventListener("click", this.colseRemark);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.colseRemark);
    document.removeEventListener("click", this.colseRemark);
  },
  methods: {
    //图片粘贴处理
    ImgpasteFun(event,type){
      console.log(event,type);
      var isChrome = false;
      let self = this
      if (event.clipboardData || event.originalEvent) {
          //某些chrome版本使用的是event.originalEvent
          var clipboardData = (event.clipboardData || event.originalEvent.clipboardData);
          if(clipboardData.items){
              // for chrome
              var  items = clipboardData.items,
                  len = items.length,
                  blob = null;
              isChrome = true;
              for (var i = 0; i < len; i++) {
                  console.log(items[i]);
                  if (items[i].type.indexOf("image") !== -1) {
                      //getAsFile() 此方法只是living standard firefox ie11 并不支持
                      blob = items[i].getAsFile();
                  }
              }
              if(blob!==null){
                  // var blobUrl=URL.createObjectURL(blob);
                  // console.log(blobUrl,'blob对象')
                  //blob对象显示(回显)
                  // document.getElementById("imgNode").src=blobUrl;
                  var reader = new FileReader();
                  //base64码显示
                  reader.onload = function (event) {
                      // event.target.result 即为图片的Base64编码字符串
                      let base64_str = event.target.result;
                      // console.log(base64_str) 
                      let imgbase64 = base64_str.replace(/^data:image\/\w+;base64,/, "");//去掉base64位头部
                      home
                        .analysisImageAddress(self, imgbase64)
                        .then((res) => {
                          if (res.success) {
                            if (res.data.length == 1) {
                              let data = res.data[0]
                              self.ruleForm[type].pca = [
                                data.province_code,
                                data.city_code,
                                data.district_code,
                              ]
                              self.ruleForm[type].name = data.name || ''
                              self.ruleForm[type].phone = data.phone || ''
                              self.ruleForm[type].province = data.province_name || ''
                              self.ruleForm[type].city = data.city_name || ''
                              self.ruleForm[type].area = data.district_name || ''
                              self.ruleForm[type].province_code = data.province_code || ''
                              self.ruleForm[type].city_code = data.city_code || ''
                              self.ruleForm[type].area_code = data.district_code || ''
                              self.ruleForm[type].address = data.address || ''
                              self.ruleForm[type].analysis = data.origin_address || ''
                              self.checkDizhi()
                              if (this.orderType=='customerSend'&&type == 'send') self.idChecked()
                            }
                            if (res.data.length > 1 && type != 'send') {
                              this.anslsList = res.data
                              this.moreVisble = true
                              this.fitInit()
                            }
                          } else {
                            self.$set(self.ruleForm[type], 'isAnalysis', false)
                          }
                        })
                        .catch((err) => {
                          self.$message({
                            type: 'warning',
                            message:
                              '错误返回' + JSON.stringify(self.ruleForm[type] + type + err),
                          })
                          self.$set(self.ruleForm[type], 'isAnalysis', false)
                        })
                  }
                  reader.readAsDataURL(blob);
              }
          }
      }
    },
    colseRemark(event){
      if(this.isShowRemarksPop){
        this.isShowRemarksPop = false
      }
    },
    handleSaveRemarks(){
      let str = this.addRemarkTemp.trim().substr(0, 60)
      home.saveRemarks(this,str).then((res) => {
        this.addRemarkTemp = ''
        home.getRemarks(this).then((res) => {
          this.remarkArrs = res.data.data.remarks
        })
      })
    },
    showDel(){
      this.showDelIcion = true
    },
    hideDel(){
      this.showDelIcion = false
    },
    handleDelRmearks(e){
      let str = e
      home.delRemarks(this,str).then((res) => {
        home.getRemarks(this).then((res) => {
          this.remarkArrs = res.data.data.remarks
        })
      })
    },
    selectRemarks(e){
      let arr = this.remarkArrs,remarksStrArr='';
      arr.forEach((item) => {
        if(e.commonly_order_remark_id == item.commonly_order_remark_id){
          item.checked = !item.checked
        }
      })
      arr.forEach((item) => {
        if(item.checked){
          remarksStrArr += item.commonly_order_remark + '，'
        }
      })
      if (this.textarea.indexOf(e.commonly_order_remark) == -1) {
        let temp;
				if (this.textarea === '') {
					temp = e.commonly_order_remark
				} else {
					temp = this.textarea + '，' + e.commonly_order_remark
				}
        this.textarea = temp.trim().substr(0, 60)
			}
      this.isShowRemarksPop = false
    },
    focusRemarkPop(){
      this.isShowRemarksPop=true
    },
    cropperImg(e,type){
      this.$refs.ImgCropper.cropperShow = true
      this.$refs.ImgCropper.Imgupdate(e,type);
    },
    inputClear(type){
      if(type == 'send'){this.focusmodel=false};
      this.ruleForm[type].analysis = ''; // 解析数据
      this.ruleForm[type].isAnalysis = false;
      this.ruleForm[type].name = '';// 姓名
      this.ruleForm[type].phone = '';// 手机号
      this.ruleForm[type].province =  ''; // 省
      this.ruleForm[type].province_code =  ''; //省编码
      this.ruleForm[type].city =  ''; // 市
      this.ruleForm[type].city_code =  ''; //市编码
      this.ruleForm[type].city_list =  []; // 市列表
      this.ruleForm[type].area =  '';
      this.ruleForm[type].area_code =  ''; //区编码
      this.ruleForm[type].area_list =  []; //区列表
      this.ruleForm[type].address =  '';// 详细地址
      this.ruleForm[type].pca =  ''; // 省市区
      this.ruleForm[type].type =  '';//类型
      this.ruleForm[type].status_desc =  '';
      this.ruleForm[type].address_id =  0; 
    },
    editAddressRow(index){
      this.title = "编辑收件人信息";
      this.collectShow = true;
      this.addOredit.type = "edit";
      this.editObj = this.Added_Collect[index];
      this.editObj.index = index
    },
    servicesType(val){
      this.onlykdy = val
    },
    setPreSave() {
      // if(this.orderType=='send'){
        const preSave = {
          ruleForm: this.ruleForm,
          typeContent: this.typeContent,
          goods_weight:this.goods_weight,
          textarea: this.textarea,
          Added_Collect: this.Added_Collect,
        }
        // console.log('preSave',preSave)
        // console.log('preSave1',JSON.stringify(preSave))
        myLocalStorage.setItem('preSave', JSON.stringify(preSave))
      // }
    },
    removePresave() {
      const oldpreSave = myLocalStorage.getItem('preSave')
      if (oldpreSave) {
        const preSave = JSON.parse(oldpreSave)
        const mextSend = {
          ruleForm: { send: preSave.ruleForm.send },
          typeContent: preSave.typeContent,
        }
        localStorage.removeItem('preSave')
        myLocalStorage.setItem('preSave', JSON.stringify(mextSend))
      }
    },
    //失焦判断
    checkDizhi(e) {
      const {
        address,
        province_code,
        city_code,
        area_code,
        province,
        city,
        area,
      } = this.ruleForm.collect
      if (province_code && city_code && area_code && address) {
        const checkQuery = [
          {
            index: 0,
            receiver_province: province,
            receiver_city: city,
            receiver_district: area,
            receiver_address: address,
            sender_province: this.ruleForm.send.province,
            sender_city: this.ruleForm.send.city,
            sender_district: this.ruleForm.send.district,
            sender_address: this.ruleForm.send.address,
          },
        ]
        home.checkaddress(this, checkQuery).then((res) => {
          if (res.success) {
            res.data[0].status_desc != '正常'
              ? (this.addressClose = true)
              : (this.addressClose = false)
            this.ruleForm.collect.status_desc = res.data[0].status_desc
            if (e == 'sure') {
              const index = this.Added_Collect.length -1
              this.addressClose = false
              this.ruleForm.collect.analysis = ''
              let item = this.Added_Collect[index];
              item.status_desc = res.data[0].status_desc
              this.$set(this.Added_Collect,index,item)
            }
            this.setPreSave()
          }
        })
      } else {
        this.addressClose = false
      }
    },
    moneyInput(value) {
      const newVal = value.replace(/[^\d.]/g, '')
      if (newVal > 0 && newVal < 10000) {
        this.daofu_amount = newVal
      }
      if (newVal <= 0) {
        this.daofu_amount = ''
      }
      if (newVal >= 10000) {
        this.daofu_amount = 9999 + '.00'
      }
    },
    moenyBlur() {
      if (this.daofu_amount > 0) {
        this.daofu_amount = (this.daofu_amount - 0).toFixed(2)
      } else {
        this.daofu_amount = ''
      }
    },
    querySearch(queryString, cb, addressType) {
      home.lxAddress(this, queryString, addressType).then((res) => {
        var restaurants = []
        if (res.success) {
          restaurants = res.data.map((el) => {
            return {
              value:
                el.name +
                ' ' +
                el.phone +
                ' ' +
                el.province_name +
                ' ' +
                el.city_name +
                ' ' +
                el.district_name +
                ' ' +
                el.address,
              id: el.id,
              name: el.name,
            }
          })
        }
        if(cb){
          var results = queryString
            ? restaurants.filter(this.createFilter(queryString))
            : restaurants
          // 调用 callback 返回建议列表的数据
          clearTimeout(this.timeout)
          this.searchTimeout = setTimeout(() => {
            cb(results)
          }, 3000 * Math.random())
        }else{
          setTimeout(() => {
            this.restaurants = restaurants
          }, 200);
        }
      })
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handleSelect(item, type) {
      home.getAddressById(this, item.id).then((res) => {
        if (res.success) {
          const result = res.data
          this.ruleForm[type] = {
            name: result.name,
            phone: result.phone,
            province: result.province_name,
            province_code: result.province_code,
            city: result.city_name,
            city_code: result.city_code,
            area: result.district_name,
            area_code: result.district_code,
            address: result.address,
            pca: [result.province_code, result.city_code, result.district_code], // 省市区
          }
        }
      })
    },
    //选择到付提示
    serveChoose(val) {
      if (val == 'pt') {
        this.daofu_amount = ''
      }else{
        const {sg_switch,bj_switch,ds_switch,qd_switch} = this.$refs.valueAdd 
        if(sg_switch){
          util.gj_message('到付单不支持水果件')
          this.maiServe = 'pt'
          return
        }
        if(bj_switch){
          util.gj_message('到付单不支持保价')
          this.maiServe = 'pt'
          return
        }
        if(ds_switch){
          util.gj_message('到付单不支持代收货款')
          this.maiServe = 'pt'
          return
        }
        if(qd_switch){
          util.gj_message('到付单不支持签单返回')
          this.maiServe = 'pt'
          return
        }
      }
    },
    //查询是否有到付权限
    getdfAuth() {
      const Istopay = util.getJsonValues(this.$store.state.commondict,'exvaluelist')
      if(!JSON.parse(Istopay)){
        this.addserve = [{ label: '寄付', value: 'pt' }]
      }else{
        this.addserve = [
          { label: '寄付', value: 'pt'},
          { label: '到付', value: 'topay'},
        ]
      }
      // home.addAuth(this).then((res) => {
      //   if (res.success && res.data.topay) {
      //     this.topayOnoff = true
      //   }
      // })
    },
    typeChoose(val) {
      this.setPreSave()
    },
    switchTip(val) {
      if (val) {
        this.package_count = 2
      } else {
        this.package_count = 1
      }
      if (this.Added_Collect.length > 0 && this.checkFiled()) {
        this.switchShow = false
        this.package_count = 1
        this.$message.warning('已同时选多个收件人时不支持批货寄件功能')
      }
      if (this.Added_Collect.length > 1 && !this.checkFiled()) {
        this.switchShow = false
        this.package_count = 1
        this.$message.warning('已同时选多个收件人时不支持批货寄件功能')
      }
    },
    /** 提交协议快递员 */
    submitKdy() {
      sumbitType = 1;
      this.Isprint = false;
      this.formCheck()
    },
    /** 直接打印 */
    directPrint() {
      sumbitType = 0
      const { lodopStatus, WebSocketstatus, name } =
        this.$store.state.connetStatus
      if (!lodopStatus || !WebSocketstatus || !name) {
        this.$printError(true)
        return
      }
      this.Isprint = true
      this.formCheck()
    },
    /** 稍后打印 */
    waitPrint() {
      sumbitType = 0;
      this.Isprint = false;
      this.formCheck()
    },
    //公共表单校验,下单接口前置调用
    formCheck() {
      this.changeTrigger('change')
      if (this.Added_Collect.length > 0 && !this.checkFiled()) {
        if(this.sendModel == '选择寄件人'){
          if(this.chooseAddress){
            this.save_btn = true
            this.createParcel()
          }else{
            util.gj_message('请选择寄件人')
          }
        }else{
          this.validateFields(this.fieldSend, 'send', 'save')
        }
      } else if (this.Added_Collect.length > 0 && this.checkFiled()) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.save_btn = true
            if (
              this.ruleForm.collect.name ||
              this.ruleForm.collect.phone ||
              this.ruleForm.collect.address ||
              this.ruleForm.collect.province ||
              this.ruleForm.collect.city ||
              this.ruleForm.collect.area ||
              this.ruleForm.collect.pca.length
            ) {
              this.confirms()
              return
            }
          } else {
            this.$message.error('打印信息填写有误，请查看重新填写')
            this.confirms()
            return false
          }
        })
      } else {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.save_btn = true
            this.createParcel()
          } else {
            this.$message.error('寄件信息填写有误，请查看重新填写')
            return false
          }
        })
      }
    },
    getCityData() {
      this.sender_address = this.ysbAddressFile.getcity()
    },
    /** 遍历地址 */
    forAddress(type) {
      let data = this.ruleForm[type]
      let res = []
      cityData.cityData.forEach((item) => {
        if (item.label == data.province) {
          res = [...res, item.value]
          item.children.forEach((ite) => {
            if (ite.label == data.city) {
              res = [...res, ite.value]
              ite.children.forEach((it) => {
                if (it.label == data.area) {
                  res = [...res, it.value]
                }
              })
            }
          })
        }
      })
      this.ruleForm[type].pca = res
    },
    /**关闭对应的Dialog */
    closeDialog() {
      this.dialog = false
    },

    /** 地址解析 */
    doAnalysis(analysis, type) {
      console.log(analysis, type)
      let self = this
      home
        .doAnalysis(self, analysis)
        .then((res) => {
          if (res.success) {
            if (res.data.length == 1) {
              let data = res.data[0]
              self.ruleForm[type].pca = [
                data.province_code,
                data.city_code,
                data.district_code,
              ]
              self.ruleForm[type].name = data.name || ''
              self.ruleForm[type].phone = data.phone || ''
              self.ruleForm[type].province = data.province_name || ''
              self.ruleForm[type].city = data.city_name || ''
              self.ruleForm[type].area = data.district_name || ''
              self.ruleForm[type].province_code = data.province_code || ''
              self.ruleForm[type].city_code = data.city_code || ''
              self.ruleForm[type].area_code = data.district_code || ''
              self.ruleForm[type].address = data.address || ''
              self.checkDizhi()
              if (this.orderType=='customerSend'&&type == 'send') self.idChecked()
            }
            if (res.data.length > 1 && type != 'send') {
              this.anslsList = res.data
              this.moreVisble = true
              this.fitInit()
            }
          } else {
            self.$set(self.ruleForm[type], 'isAnalysis', false)
          }
        })
        .catch((err) => {
          self.$message({
            type: 'warning',
            message:
              '错误返回' + JSON.stringify(self.ruleForm[type] + type + err),
          })
          self.$set(self.ruleForm[type], 'isAnalysis', false)
        })
    },

    jxBtnfun(analysis, type) {
      let self = this
      if (!self.ruleForm[type].analysis) {
        self.$message({
          type: 'warning',
          message: '请填写解析内容',
        })
        return
      }
      home.doAnalysis(self, analysis).then((res) => {
        if (res.success) {
          if (res.data.length == 1) {
            let data = res.data[0]
            self.ruleForm[type].pca = [
              data.province_code,
              data.city_code,
              data.district_code,
            ]
            self.ruleForm[type].name = data.name
            self.ruleForm[type].phone = data.phone
            self.ruleForm[type].province = data.province_name
            self.ruleForm[type].city = data.city_name
            self.ruleForm[type].area = data.district_name
            self.ruleForm[type].province_code = data.province_code
            self.ruleForm[type].city_code = data.city_code
            self.ruleForm[type].area_code = data.district_code
            self.ruleForm[type].address = data.address
          }
          if (res.data.length > 1) {
            this.anslsList = res.data
            this.fitInit()
          }
        }
      })
    },
    //确定使用
    sureUse() {
      this.moreVisble = false
      const checkQuery = this.rightArr.map((el, index) => {
        return {
          index: index,
          receiver_province: el.province_name,
          receiver_city: el.city_name,
          receiver_district: el.district_name,
          receiver_address: el.address,
          sender_province: this.ruleForm.send.province,
          sender_city: this.ruleForm.send.city,
          sender_district: this.ruleForm.send.district,
          sender_address: this.ruleForm.send.address,
        }
      })
      home.checkaddress(this, checkQuery).then((res) => {
        if (res.success) {
          const checkRes = res.data
          let addrightArr = this.rightArr.map((el, index) => {
            return {
              name: el.name,
              phone: el.phone,
              province: el.province_name,
              province_code: el.province_code,
              city: el.city_name,
              city_code: el.city_code,
              area: el.district_name,
              area_code: el.district_code,
              address: el.address,
              status_desc: el.status_desc || '',
              pca: [el.province_code, el.city_code, el.district_code],
              status_desc: checkRes[index].status_desc,
            }
          })
          this.Added_Collect = [...this.Added_Collect, ...addrightArr]
        }
      })
    },
    //数组筛选
    fitInit() {
      let rightArr = []
      const anslsList = this.anslsList
      for (let i = 0, len = anslsList.length; i < len; i++) {
        if (
          !anslsList[i].name_error &&
          !anslsList[i].phone_error &&
          !anslsList[i].address_error
        ) {
          rightArr.push({
            address: anslsList[i].address,
            city_code: anslsList[i].city_code,
            city_name: anslsList[i].city_name,
            district_code: anslsList[i].district_code,
            district_name: anslsList[i].district_name,
            name: anslsList[i].name,
            phone: anslsList[i].phone,
            province_code: anslsList[i].province_code,
            province_name: anslsList[i].province_name,
          })
        }
      }
      this.rightArr = rightArr
      this.errorNum = this.anslsList.length - rightArr.length
      this.rightNum = rightArr.length
    },
    //实名弹窗展示
    showRealnameBox() {
      let c = () => import(`@/components/realName`)
      this.curComponent = [c, 'realNameRef']
    },
    /**前置判断 */
    async createParcel() {
      if(!this.$refs.valueAdd.value_checkRrror()){
         return  
      }
      if(!this.typeContent){
         this.$message.error('请选择物品类型')
         this.showGoodsPicker = true
         return
      }
      const checkYwyreal = await bindKdy.checkRealName(this);
      if(checkYwyreal.code == '7022'){
        this.$alert('检测到当前账号为业务员身份证号实名,为了正常使用请更新该账号实名', '提示', {
          confirmButtonText: '去实名',
          showClose:false,
          callback: action => {
            this.showRealnameBox()
          }});
          return 
      }
      if (this.orderType=='customerSend'&&!this.realFlag) {
        this.dialogFormVisible = true
        this.$message.error('请先进行实名认证')
        return
      }
      if (sumbitType == 1 && this.$store.state.bindKdy == 10) {
        this.$message.warning(
          '您当前未与快递员建立协议关系，无法提交快递员打印'
        )
        return
      }
      let words = []
      let receiverData = []
      if (this.Added_Collect.length > 0) {
        this.Added_Collect.forEach((el, index) => {
          receiverData.push({
            origin_words: util.trimAll(el.address),
            index: index + 2,
          })
        })
        words = [
          { index: 0, origin_words: util.trimAll(this.textarea) },
          { index: 1, origin_words: util.trimAll(this.ruleForm.send.address) },
          ...receiverData,
        ]
      } else {
        words = [
          { index: 0, origin_words: util.trimAll(this.textarea) },
          { index: 1, origin_words: util.trimAll(this.ruleForm.send.address) },
          {
            index: 2,
            origin_words: util.trimAll(this.ruleForm.collect.address),
          },
        ]
      }
      home.sensitivewords(this, words).then((res) => {
        if (res.success) {
          const resultArr = res.data
          let filwordsArr = resultArr.filter(
            (el) => el.origin_words != el.sensitive_words
          )
          if (filwordsArr.length) {
            this.textarea = resultArr[0].sensitive_words
            this.ruleForm.send.address = resultArr[1].sensitive_words
            if (receiverData.length == 0) {
              this.ruleForm.collect.address = resultArr[2].sensitive_words
            } else {
              let oldreceiver = this.Added_Collect
              for (let i = 2; i < resultArr.length; i++) {
                oldreceiver[i - 2].address = resultArr[i].sensitive_words
              }
              this.Added_Collect = oldreceiver
            }
            this.setPreSave()
            this.$confirm(
              '您输入的信息中含有敏感词请修改后重新操作点击忽略订单中将以“□”代替',
              '提示',
              {
                confirmButtonText: '忽略',
                cancelButtonText: '去修改',
                type: 'warning',
              }
            )
              .then(() => {
                this.tingfa_jg()
              })
              .catch(() => {})
          } else {
            this.tingfa_jg()
          }
        }
      })
    },
    //停发区判断
    tingfa_jg() {
      const tingfaFlag = this.Added_Collect.some(
        (el) => el.status_desc != '正常'
      )
      if (this.addressClose || tingfaFlag) {
        let tingfa = { content: '', ok: '继续保存', cacel: '再考虑下' }
        if (this.Isprint) {
          tingfa.content =
            '此订单暂时存在“网点停发”情况,无法获取运单号,是否保存订单到待打印中'
        } else {
          if (sumbitType == 1) {
            tingfa.content =
              '此订单暂时存在“网点停发”情况，无法提交快递员，是否保存订单到待打印中'
          } else {
            tingfa.content =
              '此订单暂时存在“网点停发”情况，是否继续保存订单到待打印中'
          }
        }
        this.$confirm(tingfa.content, '提示', {
          confirmButtonText: tingfa.ok,
          cancelButtonText: tingfa.cacel,
          type: 'warning',
        })
          .then(() => {
            this.faceLesswarn()
          })
          .catch(() => {})
      } else {
        this.faceLesswarn()
      }
    },
    //面单不足提醒
    async faceLesswarn(){
      let result = await print.ywyauthorize()
      if(this.Isprint || sumbitType == 1){ //打印或提交快递员
        if(!result.success){
          const data = result.data;
          if(data.code == 9003){ //面单授权未开启
            if([1,2].includes(data.data.team_role)){  //团长或个人
              this.$toast(true,{
                title:'面单授权未开启',
                htmlstring:'<div>当前面单授权未开启，请联系合作快递员</div>'+
                '<div>“'+data.data.ywy_name+'”确定授权状态</div>'+
                '<div>快递员电话：'+data.data.ywy_phone+'</div>'
              },'ywyauthorize',()=>{
                // this.createActions()
              })
            }else{ //团员
              this.$toast(true,{
                title:'面单授权未开启',
                htmlstring:'<div>当前面单授权未开启，请尽快联系团长</div>'+
                '<div>向合作快递员确定授权状态</div>'
              },'ywyauthorize',()=>{
                // this.createActions()
              })
            }
          }else if(data.code == 9004){ //面单余额不足
            if([1,2].includes(data.data.team_role)){  //团长或个人
              this.$toast(true,{
                title:'面单余量过低提醒',
                htmlstring:'<div>当前剩余单量'+data.data.left_value+'单，请联系合作快递员</div>'+
                '<div>“'+data.data.ywy_name+'”充值面单</div>'+
                '<div>快递员电话：'+data.data.ywy_phone+'</div>'
              },'ywyauthorize',()=>{
                this.createActions()
              })
            }else{ //团员
              this.$toast(true,{
                title:'面单余量过低提醒',
                htmlstring:'<div>当前剩余单量'+data.data.left_value+'单，请尽快联系团长</div>'+
                '<div>充值面单</div>'
              },'ywyauthorize',()=>{
                this.createActions()
              })
            }
          }else{
           this.$message.error('查询面单余量失败code-'+ data.code)
          }
        }else{
          this.createActions()
        }
      }else{
        this.createActions()
      }
    },
    //下单交互
    createActions() {
      if (this.first_click) {
        this.first_click = false
        let collectArr = []
        let data = []
        let collectObj = this.ruleForm.collect
        let multiple = []
        if (this.Added_Collect.length > 0) {
          this.Added_Collect.forEach((item) => {
            let obj = {
              account_id: util.getCookie('account_id'),
              receiver_name: item.name,
              receiver_phone: item.phone,
              receiver_province: item.province,
              receiver_province_code: item.province_code,
              receiver_city: item.city,
              receiver_city_code: item.city_code,
              receiver_district: item.area,
              receiver_district_code: item.area_code,
              receiver_address: item.address,
              address_id: item.id,
            }
            if (item.type == 'add') {
              collectArr.push(obj)
            }
            data.push(obj)
          })
        } else {
          let obj = {
            account_id: util.getCookie('account_id'),
            receiver_name: collectObj.name,
            receiver_phone: collectObj.phone,
            receiver_province: collectObj.province,
            receiver_province_code: collectObj.province_code,
            receiver_city: collectObj.city,
            receiver_city_code: collectObj.city_code,
            receiver_district: collectObj.area,
            receiver_district_code: collectObj.area_code,
            receiver_address: collectObj.address,
            address_id: collectObj.address_id,
          }
          collectArr.push(obj)
          data.push(obj)
          home.CreateAddress(this, 'collect')
        }
        if (this.ruleForm.send.save_info) {
          home.CreateAddress(this, 'send', 'S')
        }
        let val_addObj = this.$refs.valueAdd.besure()
        let queryData = {
            account_id: util.getCookie("account_id"),
            item_type: this.typeContent,
            goods_weight:this.goods_weight,
            item_note: this.textarea, //物品备注
            package_count:this.package_count,
            value_add_type:this.maiServe,  //增值服务
            daofu_amount:this.daofu_amount, // 到付金额
            express_type:val_addObj.zc_switch ? "TK" : "PK", //智橙网服务
            // pri:"PRI", // 隐私面单
            marking_infos:val_addObj.marking_infos, //保价，代收货款，签收统计等增值服务
            order_address_data: {
              account_id: util.getCookie("account_id"), //用户id
              order_receiver_address_data_list: data,
              sender_name: this.ruleForm.send.name, //寄件人姓名
              sender_phone: this.ruleForm.send.phone, //寄件人电话
              sender_province: this.ruleForm.send.province, //寄件人省
              sender_province_code: this.ruleForm.send.province_code, //寄件人省
              sender_city: this.ruleForm.send.city, //寄件人市
              sender_city_code: this.ruleForm.send.city_code, //寄件人市
              sender_district: this.ruleForm.send.area, //寄件人区
              sender_district_code: this.ruleForm.send.area_code, //寄件人区
              sender_address: this.ruleForm.send.address, //寄件人地址
              address_id:this.ruleForm.send.address_id//寄件人地址 id
            },
        }
        if (this.Isprint) {
          this.Isprint = false;
          queryData.template_platform = "lodop"
          // queryData.printer_name = util.getCookie('defult_print') || ''
          queryData.source = this.orderType=='customerSend'?13:5
          if(this.orderType=='customerSend'){
            queryData.name=this.realForm.name
            queryData.id_card=this.realForm.id
          }
          home.Printing(this, queryData).then((res) => {
            if (res.success) {
              this.$message.success(
                '打印信息已成功提交至' +
                  util.getCookie('defult_print') +
                  '打印,若打印机长时间不出纸，可以F5刷新浏览器后再次操作'
              )
              const result = res.data
              PrintWaiting(this).then((res) => {
                if (res.initPrint) {
                  const pagenum =
                    util.getJsonValues(
                      this.$store.state.commondict,
                      'packsize'
                    ) - 0 || 10
                  var groupedArray = util.arrayGroup(result, pagenum)
                  for (let i = 0; i < groupedArray.length; i++) {
                    print.printData(this, groupedArray[i]).then((res) => {
                      if (res.success) {
                        startPrinting(res.data).then(() => {
                          this.clearstorage = true
                          this.removePresave()
                          setTimeout(() => {
                            this.$parent.$refs.menuNav.goPath(3, '/printed')
                            this.first_click = true
                            this.save_btn = false
                          }, 1000)
                        })
                      }
                    })
                  }
                }
              })
            } else {
              if (
                [7010, 7011, 7012, 7013, 7018, 7019].includes(~~res.data.code)
              ) {
                this.clearstorage = true
                this.removePresave()
                setTimeout(() => {
                  this.$parent.$refs.menuNav.goPath(2, '/waitPrinted')
                  this.first_click = true
                  this.save_btn = false
                }, 1000)
              } else {
                if (res.data.code == 201) {
                  this.showRealnameBox()
                }
                this.first_click = true
                this.save_btn = false
              }
            }
          })
        } else {
          queryData.is_submit_ywy = sumbitType  //是否提交协议快递员  1 提交 0不提交
          queryData.source = this.orderType=='customerSend'?13:sumbitType == 0 ? 6 : 4  //1小程序提交业务员 3小程序先存后打 
          if(this.orderType=='customerSend'){
            queryData.name=this.realForm.name
            queryData.id_card=this.realForm.id
          }
          home.createParcel(this, queryData).then((res) => {
            if (~~res.success) {
              if (sumbitType == 1) {
                this.$message.success('提交快递员成功!')
              } else {
                this.$message.success('保存成功!')
              }
              this.clearstorage = true
              this.removePresave()
              setTimeout(() => {
                this.first_click = true
                this.save_btn = false
                this.$parent.$refs.menuNav.goPath(2, '/waitPrinted')
              }, 1000)
            } else {
              if ([7010, 7011, 7012, 7013, 7018, 7019].includes(~~res.data.code) && sumbitType != 1) {
                this.clearstorage = true
                this.removePresave()
                setTimeout(() => {
                  this.$parent.$refs.menuNav.goPath(2, '/waitPrinted')
                }, 1000)
              } else {
                if (res.data.code == 201) {
                  this.showRealnameBox()
                }
              }
              this.first_click = true
              this.save_btn = false
            }
          })
        }
      } else {
        this.$message({
          type: 'warning ',
          message: '单击次数过快，请稍后再试',
        })
        return
      }
    },
    /** 选择地址 */
    selectAddress(type) {
      this.address_type = type
      if (type == 'send') {
        this.dialog_title = '选择寄件人'
        setTimeout(() => {
          this.$refs.sendList.$refs.singleTable.clearSelection()
        }, 100)
      } else {
        // if(this.orderType=='customerSend' && this.Added_Collect.length>=30){
        //   this.$message({
        //     type: 'warning ',
        //     message:'单批添加最多支持 30 个收件人!'
        //   })
        //   return
        // }
        const IdList = []
        for (let i = 0, len = this.Added_Collect.length; i < len; i++) {
          IdList.push(this.Added_Collect[i].id)
        }
        this.IdList = IdList
        this.dialog_title = '选择收件人'
        setTimeout(() => {
          this.$refs.collectList.$refs.multipleTable.clearSelection()
        }, 100)
      }
      this.dialog = true
    },
    /** 编辑地址 */
    editAddress(index) {
      let editObj = this.Added_Collect[index]
      this.editcollectIndex = index
      this.ruleForm.collect = Object.assign(this.ruleForm.collect, editObj)
    },
    /**手动继续添加收件人 */
    addCollect() {
      if (this.Added_Collect.length >= 1 && this.switchShow) {
        this.$message.warning('已开启批货寄件功能，不支持同时选择多个收件人')
        return
      }
      if(this.orderType=='customerSend' && this.Added_Collect.length>=30){
        this.$message({
          type: 'warning ',
          message:'单批添加最多支持 30 个收件人!'
        })
        return
      }
      this.changeTrigger('change')
      this.validateFields(this.fieldCollect, 'collect')
    },

    /** 删除收件人地址 */
    removeAddress(index) {
      this.Added_Collect.splice(index, 1)
      this.setPreSave()
    },
    /**校验收寄/收件人字段规则 */
    validateFields(fieldArr, type, from) {
      let success = []
      let _this = this
      this.$refs.ruleForm.validateField(fieldArr, (result) => {
        if (result != '') {
          // console.log("来自" + type + "有不满足的校验规则的");
          this.result = false
        } else {
          // console.log("来自" + type + "有满足校验规则");
          success.push(1)
          if (success.length == 4) {
            this.result = true
            if (type == 'collect' && from != 'save') {
              this.ruleForm.collect.type = 'add'
              let collectObj = {}
              const item = _this.ruleForm.collect
              collectObj.id = item.id
              collectObj.receiver_name = item.name
              collectObj.receiver_phone = item.phone
              collectObj.receiver_province_code = item.province_code
              collectObj.receiver_city_code = item.city_code
              collectObj.receiver_district_code = item.area_code
              collectObj.receiver_address = item.address
              collectObj.address_id = item.address_id
              home.CreateAddress(this, 'collect', 'R', collectObj)
              if (_this.editcollectIndex == -1) {
                this.Added_Collect.push(
                  JSON.parse(JSON.stringify(this.ruleForm.collect))
                )
              } else {
                this.Added_Collect[_this.editcollectIndex] = JSON.parse(
                  JSON.stringify(this.ruleForm.collect)
                )
                _this.editcollectIndex == -1
              }
              this.checkDizhi('sure')
              this.restFiled()
              this.changeTrigger('blur')
            }
            if (type == 'send' && from == 'save') {
              this.save_btn = true
              this.createParcel()
            }
          }
        }
      })
      setTimeout(() => {
        if (success.length != 4) {
          this.$message.error('打印信息填写有误，请查看重新填写')
        }
      }, 100)
    },

    /**改变校验规则触发状态 */
    changeTrigger(status) {
      this.rules['collect.name'][0].trigger = status
      this.rules['collect.phone'][0].trigger = status
      this.rules['collect.address'][0].trigger = status
      this.rules['collect.province'][0].trigger = status
      this.rules['collect.city'][0].trigger = status
      this.rules['collect.area'][0].trigger = status
    },

    /**checkFiled */
    checkFiled() {
      if (
        this.ruleForm.collect.name ||
        this.ruleForm.collect.phone ||
        this.ruleForm.collect.address ||
        this.ruleForm.collect.province ||
        this.ruleForm.collect.city ||
        this.ruleForm.collect.area ||
        this.ruleForm.collect.pca.length
      ) {
        return true
      } else {
        this.$refs.ruleForm.clearValidate(this.fieldCollect)
        return false
      }
    },

    /**重置字段 */
    restFiled() {
      this.ruleForm.collect.name = ''
      this.ruleForm.collect.phone = ''
      this.ruleForm.collect.province = ''
      this.ruleForm.collect.area = ''
      this.ruleForm.collect.city = ''
      this.ruleForm.collect.address = ''
      this.ruleForm.collect.pca = ''
      this.ruleForm.collect.area_code = ''
      this.ruleForm.collect.province_code = ''
      this.ruleForm.collect.city_code = ''
    },

    /**Error-Message */
    confirms() {
      let self = this
      self
        .$confirm(
          '收件信息输入框中有未确认信息，请点击【确认添加收件信息】，或清空所有输入框信息后再保存',
          '提示',
          {
            confirmButtonText: '确认添加收件信息',
            cancelButtonText: '一键清空输入框',
            type: 'warning',
          }
        )
        .then(() => {
          // 继续完成添加
          this.addCollect()
          self.save_btn = false
        })
        .catch(() => {
          // 一键清空输入框c
          self.save_btn = false
          self.restFiled()
          self.changeTrigger('blur')
          self.$refs.ruleForm.clearValidate()
        })
    },
    /**取消 */
    cancel() {
      this.$router.go(-1) //返回上一层
    },
    /** 解析绑定地址 */
    changeAddress(type) {
      if (!type) return
      let address = this.$refs[type].getCheckedNodes()[0].pathLabels // 地址显示
      let code = this.$refs[type].getCheckedNodes()[0].path // 地区编码
      this.ruleForm[type].province = address[0]
      this.ruleForm[type].province_code = code[0]
      this.ruleForm[type].city = address[1]
      this.ruleForm[type].city_code = code[1]
      this.ruleForm[type].area = address[2]
      this.ruleForm[type].area_code = code[2]
    },
    /** 获取默认寄件地址 */
    getmorenAddress() {
      home.getDefaultAddress(this).then((res) => {
        if (res.success) {
          const data = res.data
          this.ruleForm.send.name = data.name
          this.ruleForm.send.phone = data.phone
          this.ruleForm.send.province = data.province_name
          this.ruleForm.send.city = data.city_name
          this.ruleForm.send.area = data.district_name
          this.ruleForm.send.address = data.address
          this.ruleForm.send.province_code = data.province_code
          this.ruleForm.send.city_code = data.city_code
          this.ruleForm.send.area_code = data.district_code
          this.ruleForm.send.pca = [
            data.province_code,
            data.city_code,
            data.district_code,
          ]
        }
      })
    },
    handlePickGoods(goodObj, keep = false) {
      this.typeContent = goodObj.goods
      this.goods_weight = goodObj.weight
      this.showGoodsPicker && (this.showGoodsPicker = keep)
      this.setPreSave()
    },
    //身份证验证
    subReal() {
      this.$refs.IdCardForm.validate((valid) => {
        if (valid) {
          const number =  this.realForm.id.trim()
          const card_type = this.realForm.card_type
          if(number.length != 18 && (['04','05','07'].includes(card_type))){
            this.$message.warning('证件位数错误')
            return
          }
          if(number.length != 11 && card_type == '06'){
            this.$message.warning('证件位数错误')
            return
          }
          const regex = /^[A-Za-z]\d{8}$/;
          if(card_type == '09' && !regex.test(number)){
            this.$message.warning('证件格式错误')
            return
          }
          if(card_type == '10' && number.length < 8){
            this.$message.warning('证件位数错误')
            return
          }
          const regex2 = /^\d{18}$/
          if(card_type == '11' && !regex2.test(number)){
            this.$message.warning('证件格式错误')
            return
          }
          home.Idvalidate(this).then((res) => {
            if (res.success) {
              this.realFlag = true
              this.dialogFormVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
        //获取实名
    getReal() {
      let that = this
      const sender = this.ruleForm.send
      const query = {
        sender_name: sender.name,
        sender_phone: sender.phone,
      }
      return new Promise((resolve, reject) => {
        home.saveIdinfo(that, query).then((res) => {
          if (res.success) {
            if (res.data) {
              that.realFlag = true
              ;(that.realForm = {
                name: res.data.name,
                id: res.data.id_card,
              }),
                resolve({
                  success: true,
                })
            } else {
              resolve({
                success: false,
              })
            }
          }
        })
      })
    },
    // 查询暂时身份信息 并监听
    idChecked() {
      if (this.orderType=='send'){
        return
      }
      const query = {
        sender_name: this.ruleForm.send.name,
        sender_phone: this.ruleForm.send.phone,
      }
      const idFlag =
        query.sender_phone.length < 12 &&
        (telReg.test(query.sender_phone) ||
          phoneReg.test(query.sender_phone) ||
          ghReg.test(query.sender_phone))
      if (!query.sender_name && !idFlag) {
        console.log(
          '条件缺失',
          query,
          telReg.test(query.sender_phone),
          phoneReg.test(query.sender_phone),
          ghReg.test(query.sender_phone)
        )
      } else {
        home.saveIdinfo(this, query).then((res) => {
          if (res.success && res.data) {
            this.realFlag = true
            this.realForm = {
              name: res.data.name,
              id: res.data.id_card,
            }
          } else {
            this.realFlag = false
            this.realForm = {
              name: '',
              id: '',
            }
          }
        })
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
.home {
  padding-bottom: 90px;
  overflow-y: auto;
.mygray{
  opacity: .3;
}
  .forsign{
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #e8e8e8;
    height: 50px;
    padding: 0 40px;
    line-height: 50px;
    >div{
      margin-right 30px
      cursor: pointer;
      span{
        color #fabe00;
      }
    }
  }
  .model {
    background: #fff;
    border-radius: 4px;

    ._header {
      height: 50px;
      padding: 0 40px;
      border-bottom: 1px solid #E8E8E8;

      .left {
        float: left;
        line-height: 50px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(33, 33, 33, 1);
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 28px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }

    .from {
      padding: 20px 40px 10px 40px;
      font-size:14px;
      max-width:1000px;
      margin:0 auto;
      position: relative;
      .chooseModel{
        position: absolute;
        right: 60px;
        top: -40px;
      }
      .header_title{
        position: absolute;
        left: 0px;
        top: -36px;
        font-size:14px;
        img{
          width: 20px;
          height: 28px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
      .addRecever{
        position: absolute;
        right: 60px;
        top: -44px;
        line-height: 50px;
        font-weight: 400;
        color: rgba(28, 139, 246, 1);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        a {
          font-size: 14px;
          color: #1C8BF6;
        }
        img {
          width: 10px;
          height: 10px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }

      .flexEnd{
        display flex;
        justify-content: flex-end
      }

      >.el-row {
        margin-bottom: 20px;
      }
      .collectBox{
        background: #f5f5f5;
        padding: 20px 0 1px 0;
        border-radius: 9px;
        >.el-row {
          margin-bottom: 20px;
        }
      }
      .el-row {
        display: flex;
        align-items: center;
        font-size: 13px;

        .title {
          text-align: right;
          margin-right: 10px;
          color: #212121;
          .span {
            color: #FF0000;
            font-size: 14px;
            vertical-align: middle;
            padding-right: 4px;
          }
        }
        font{
          font-size:12px;
          color:#888888;
        }
        .input {
          /deep/ .el-form-item {
            margin-bottom: 0;

            .el-input {
              width: 97%;
              float: left;
            }

            /deep/ .el-form-item__content {
              margin: 0 !important;
            }
          }

          .el-cascader,.el-autocomplete {
            width: 97%;
            float: left;

            // margin-right:10px;
            /deep/.el-input {
              width: 100% !important;
            }
          }

          .el-select {
            width: 97%;
            float: left;

            /deep/.el-input {
              width: 100% !important;
            }
          }
        }
      }

      .checkbox {
        margin-left: 110px;
        font-size :13px;
      }

      .parse {
        background: #1C8BF6;
        color: #fff;
        border-radius: 0 4px 4px 0;
      }
    }
  }

  .addressee {
    margin-top: 0px;

    .collect-list {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      background: rgba(28, 139, 246, 0.1);
      border-radius: 4px;
      color: #212121;
      justify-content: space-between;

      .left {
        flex: 1;
        display: flex;
        align-items: center;
        .checkdes{
          background-color: red;
          color: #fff;
          padding: 4px 6px;
          border-radius: 4px;
          margin-right: 10px;
        }
        .rod {
          display: inline-block;
          width: 15px;
          height: 15px;
          border: 1px solid #333;
          border-radius: 100%;
          font-size: 12px;
          line-height: 17px;
          text-align: center;
          margin-right: 10px;
        }
      }

      .right {
        // flex-basis: 60px;
        flex-basis: 188px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        img {
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-left: 15px;
        }
      }
    }

    .save_addressee_btn {
        width: 400px;
        margin: 20px auto;

      >div {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid #1C8BF6;
        border-radius: 4px;
        transition: all 0.3s;

        a {
          color: #1C8BF6;
        }

        &:hover {
          transition: all 0.3s;
          border-color: #1C8BF6;
          background: #ECF8FF;
        }

        &:active {
          transition: all 0.3s;
          opacity: 0.7;
        }

        img {
          width: 10px;
          height: 10px;
          margin-right: 10px;
        }
      }
    }
  }
  .info-title{
    height: 22px;
    color: rgba(34,34,34,1);
    font-size: 16px;
    font-weight: 700;
    font-family: "PingFang SC";
    padding-left:40px;
    padding-bottom:10px;
    border-bottom:1px solid #e8e8e8;
    img{
      width:24px;
      height:24px;
      vertical-align: middle;
      margin-right:12px;
    }
  }
  .zzfu-n{
    margin:0 auto;
    max-width: 1000px;
    position:relative;
    .header_title{
        position: absolute;
        left: -40px;
        top: -30px;
        font-size: 14px;
        img{
          width:24px;
          height:24px;
          vertical-align: middle;
          margin-right:12px;
        }
    }
  }
  .other {
    // border-top:1px solid #E8E8E8;
    // margin-top:16px;
    // padding-top:25px;
    // position:relative;
    .scroll-n-box{
      overflow:hidden;
    }
    .remark-scroll-n{
      height:116px;
      padding:0 12px;
      overflow-y: auto;
      .itemopt-n{
        display:flex;
        justify-content: space-between;
        color: rgba(29,33,41,1);
        font-size: 14px;
        font-weight: 400;
        font-family: "PingFang SC";
        text-align: left;
        line-height: 36px;
        cursor:pointer;
      }
    }
    .select-n-box1{
      position:absolute;
      left:88px;
      bottom:-195px;
      z-index:100;
    }
    .select-n-box{
        min-width:240px;
        // min-height:100px;
        background:#fff;
        border-radius:4px;
        box-shadow: 0 0 5px #e0dede;
        padding:12px 0 10px;
      }
      .add-btn-n-box{
        // height: 52px;
        padding:10px 12px;
        border-top: 1px solid rgba(229,230,235,1);
        display:flex;
        justify-content: space-between;
         /deep/ .el-input__inner{
          background:#F2F3F5 !important;
          border:none !important;
        }
        .remark-input-n{
          width:132px;
          height:32px;
          line-height:32px;
        }
        .add-btn-n{
          height:32px;
          line-height:32px;
          color: rgba(64,158,242,1);
          font-size: 14px;
          font-weight: 400;
          font-family: "PingFang SC";
          text-align: left;
        }
      }
    .el-select,.freight-input {
      // width: 100%;
      width:145px !important;
      height:32px;
      line-height:32px;
    }

    .from {
      padding-top: 0;
      padding-left:76px;
    }

    .from > .el-row {
      margin-bottom: 0px;
    }

    .from .el-row {
      display:flex;
      align-items: flex-start;
      .title {
        margin-top: 10px;
        font-size: 14px;
      }
      /deep/ .el-input__inner{
        background:#F2F3F5;
        height:32px;
        border:none;
      }
      /deep/ .el-input__icon{
        height:32px;
        line-height:32px;
      }
      /deep/ .el-input-group__append{
        border:none !important;
        background:#F2F3F5;
        color:#1D2129;
      }
      /deep/ .el-switch__core{
        margin-bottom:2px;
      }
      /deep/ .el-input-number__decrease, /deep/ .el-input-number__increase{
        position: absolute;
        top: 0;
        width: 32px;
        height: 32px;
        background: transparent;
        color: #606266;
        font-size: 14px;
      }
      /deep/ .el-input-number--small{
        width:160px;
        margin-left:12px;
      }
      /deep/ .el-input-number--small .el-input__inner{
        padding-left:32px;
        padding-right:32px;
      }
      /deep/ .el-input .el-input__count .el-input__count-inner{
        background:transparent;
      }
      .input-box-n{
        height:32rpx;
        line-height:32rpx;
        display:flex;
        align-items: flex-start;
        margin-right:38px;
        padding-left:16px;
        margin-top:16px;
        // position: relative;
        .input-box-lable{
          height: 22px;
          color: rgba(29,33,41,1);
          font-size: 14px;
          font-weight: 400;
          font-family: "PingFang SC";
          text-align: left;
          line-height: 22px;
          padding:5px 0;
          margin-right:16px;
          span{
            color:#F53F3F;
            margin-right:8px;
            opacity:0;
          }
        }
        .pihuo-tip-n{
          padding-left: 12px;
          color: #86909C;
          line-height: 32px;
        }
        .order-renark-n{
          width:763px;
          height:32px;
          // padding-right:45px;
        }
      }
      .input-remark-n{
        /deep/  .el-input__inner{
          padding-right:52px;
        }
      }
    }

    .el-textarea {
      height: 100px;

      /deep/ .el-textarea__inner {
        height: 100%;
      }
    }
  }

  footer {
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    line-height: 40px;
    text-align: center;
    box-shadow: 1px 0 7px rgba(0, 0, 0, 0.1);
    z-index:99
    .footBtn{
        width 150px
        margin-right 50px
        padding 8px 10px
    }
  }

  /deep/.el-textarea textarea {
    resize: none;
    padding-right: 60px;
  }

  .home .other .el-textarea .el-textarea__inner {
    resize: none;
  }

  /deep/.el-textarea .el-input__count {
    line-height: 20px;
  }

  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
}
.forExample{
  display: flex;
  justify-content: flex-start;
  padding: 10px 0;
  font-size: 12px;
  color: #909399;
  .left{
    width 40px
    text-align left
  }
  .right{
    flex 1
  }
}
.cp_title{
  padding 10px 0;
  color #E6A23C;
  span{
    color #F56C6C
  }
}
.errorTip{
  color:#F56C6C
}
.ListItem span{
  padding-right:5px;
}
.flexEnd{
  padding-top 10px;
  display flex;
  justify-content: flex-end
}
#IdCard /deep/.el-form-item__content{
  margin-left: 100px !important;
}
.realBox{
  cursor: pointer;
  border: 1px solid #DCDFE6;
  height: 30px;
  line-height: 30px;
  text-align:right;
  padding:0 15px;
  border-radius: 4px;
}
.inputClear{
  z-index:5;
  position: absolute;
  right: 10px;
  top: 40px;
}
.flexBetween{
  display: flex;
  justify-content: space-between;
  position: relative;
  .picBox{
    position: absolute;
    z-index: 9;
    right: 10px;
    top:8px;
    width: 50px;
    text-align: center;
    font-size: 12px;
    color:#409EFF;
    cursor: pointer;
    i{
      font-size:24px
    }
    .file{
      position: absolute
      z-index 99
      opacity 0
      left: 0
      top:0
      width: 100%
      height: 100%
    }
  }
}
.senderChoose{
  background:#409EFF !important;
  color:#fff !important;
}
.goods-input{
  // width: 96% !important;
  width: 202px !important;
}
  
</style>
